export default __webpack_public_path__ + "static/media/gmx_logo.9b999610.svg";